export const PAHT_BY_INSTRUCTOR = {
    しーやん: "/instructor/しーやん.html",
    "SHIORI.": "/instructor/shiori.html",
    RIKIYA: "/instructor/rikiya.html",
    Reiko: "/instructor/reiko.html",
    ayano: "/instructor/ayano.html",
    ゆれこ: "/instructor/ゆれこ.html",
    MIORI: "/instructor/miori.html",
    Moe: "/instructor/Moe.html",
    もも: "/instructor/もも.html",
    Alice: "/instructor/alice.html",
    Mai: "/instructor/Mai.html",
    あやか: "/instructor/ayaka.html",
    "SakaHiro.": "/instructor/sakahiro.html",
    mizuyuzu: "/instructor/mizuyuzu.html",
    NATSUKI: "/instructor/NATSUKI.html",
    ねお: "/instructor/neo.html",
    konomi: "/instructor/konomi.html",
    YUUKA: "/instructor/yuuka.html",
    風果: "/instructor/fuka.html",
    RYOKA: "/instructor/ryoka.html",
    COCO: "/instructor/coco.html",
    TAIGA: "/instructor/taiga.html",
    yamato: "/instructor/yamato.html",
    Kotona: "/instructor/kotona.html",
    MUSA: "/instructor/musa.html",
    HARUKA: "/instructor/HARUKA.html",
    kasumi: "/instructor/kasumi.html",
    otoha: "/instructor/otoha.html",
};
